import { format, parse } from "date-fns";
import { es } from "date-fns/locale";

export const formatDateRange = (checkIn: Date, checkOut: Date): string => {
  return `${checkIn.toLocaleDateString(
    "es-ES",
  )} - ${checkOut.toLocaleDateString("es-ES")}`;
};

export const formatDateForDisplay = (
  date: Date,
  locale: string = "es-ES",
): string => {
  return date.toLocaleDateString(locale);
};

export const formatDateShort = (date: Date): string => {
  return date.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatISOToDDMMYYYY = (isoString: string): string => {
  // Deprecated: Use formatISOToDDMMYY for short format
  return formatISOToDDMMYY(isoString);
};

export const parseSpanishTextDate = (dateString: string): string => {
  try {
    const parsedDate = parse(dateString, "d 'de' MMMM 'de' yyyy", new Date(), {
      locale: es,
    });
    return format(parsedDate, "dd/MM/yyyy");
  } catch {
    return dateString;
  }
};

export const formatISOToDDMMYY = (isoString: string): string => {
  try {
    // Normalize separators to "-"
    const normalized = isoString.replace(/\//g, "-");
    
    // Check if it's yyyy-MM-dd format
    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
      const parsedDate = parse(normalized, "yyyy-MM-dd", new Date());
      return format(parsedDate, "dd/MM/yy", { locale: es });
    }
    
    // Check if it's dd-MM-yyyy format
    if (/^\d{2}-\d{2}-\d{4}$/.test(normalized)) {
      const parsedDate = parse(normalized, "dd-MM-yyyy", new Date());
      return format(parsedDate, "dd/MM/yy", { locale: es });
    }
    
    // Fallback: try to split and format manually
    const parts = normalized.split("-");
    if (parts.length === 3) {
      const [first, second, third] = parts;
      // If first part is 4 digits, assume yyyy-MM-dd
      if (first.length === 4) {
        return `${third}/${second}/${first.slice(-2)}`;
      }
      // Otherwise assume dd-MM-yyyy
      return `${first}/${second}/${third.slice(-2)}`;
    }
    
    return isoString;
  } catch {
    return isoString;
  }
};